import React from 'react';
function ArrowForwardIos() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z" }),
        React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" })));
}
export default ArrowForwardIos;
